export const PREFIX_API = "api";
export enum ApiRoute {
  HEALTH = "health",
  PROFILE = "profile",
  ORG = "org",
  REFERRAL = "referral",
  QUIZ = "quiz",
  CREDIT = "credit",
  BOOKING = "booking",
  TICKET = "ticket",
  EVENT = "event",
  INVITE = "invite",
  PUBLIC = "public",
}

export function getApiRoute(route: ApiRoute, version: string = "v1"): string {
  return `/${PREFIX_API}/${version}/${route}`;
}
